import { AxiosError } from "axios";
import { ERROR_MESSAGES } from "../constants";

interface BackendError {
  code: string;
  target: string;
  message: string;
}

interface BackendErrorResponse {
  errors: BackendError[];
}

export function getErrorMessage(
  error: unknown,
  defaultMessage: string,
): string {
  if (error instanceof Error) {
    const axiosError = error as AxiosError<
      BackendErrorResponse | { message?: string }
    >;

    if (axiosError.response?.data) {
      const responseData = axiosError.response.data;

      if (
        "errors" in responseData &&
        Array.isArray(responseData.errors) &&
        responseData.errors.length > 0
      ) {
        return responseData.errors[0].message;
      }

      if ("message" in responseData && responseData.message) {
        return responseData.message;
      }
    }

    return axiosError.message || defaultMessage;
  }
  return defaultMessage;
}

export function handleApiError(
  error: unknown,
  defaultMessage: string = ERROR_MESSAGES.DEALER_LOAD_FAILED,
): string {
  return getErrorMessage(error, defaultMessage);
}
